'use client'

import { usePathname } from 'next/navigation'
import { env } from 'utils/env'

import { isOnMobiDomain } from './isOnMobiDomain'
import { GTMAssetsState } from './RootLayout.types'

export const GtmIFrameNoScript = () => {
	const pathname = usePathname()

	let hideGTMAssets: GTMAssetsState
	if (isOnMobiDomain || pathname.startsWith('/generator/preview')) {
		hideGTMAssets = GTMAssetsState.HIDE
	} else if (pathname.startsWith('/qr/[id]/[mode]')) {
		hideGTMAssets = GTMAssetsState.PARTIAL
	} else {
		hideGTMAssets = GTMAssetsState.SHOW
	}

	if (hideGTMAssets !== GTMAssetsState.HIDE) {
		return (
			<noscript
				dangerouslySetInnerHTML={{
					__html: `<iframe src="https://www.googletagmanager.com/ns.html?id=${env.GTM_ID}" height="0" width="0" style="display: none; visibility: hidden;"></iframe>`,
				}}
			/>
		)
	}

	return null
}
